import { ShieldCheck, Calendar } from "lucide-react";

const fmt = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};

/**
 * ReviewedBadge — a compact "Medically reviewed" + "Last updated" row.
 * Uses `reviewed` (ISO date) and optional `readingTime`.
 */
const ReviewedBadge = ({ reviewed, readingTime }) => (
  <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 text-[11px] uppercase tracking-[0.22em] text-muted-foreground" data-testid="reviewed-badge">
    <span className="inline-flex items-center gap-1.5 text-[hsl(var(--primary))]">
      <ShieldCheck size={13} strokeWidth={1.8} />
      Medically reviewed by Dr. Shantanu Kumar Gupta
    </span>
    {reviewed && (
      <span className="inline-flex items-center gap-1.5">
        <Calendar size={12} strokeWidth={1.8} />
        Last updated {fmt(reviewed)}
      </span>
    )}
    {readingTime && <span>· {readingTime} min read</span>}
  </div>
);

export default ReviewedBadge;
